export default {
  columns: {
    strategy: 'Estratégia',
    source: 'Fonte',
    async: 'Async',
    content: 'Conteúdo',
    edit: 'Editar',
    delete: 'Eliminar',
  },
  buttons: {
    add_script: 'Adicionar script',
  },
};
